import { PlaycastMessage, PlaycastMessageTarget } from '../types';

export * as system from './system';
export * as remote from './remote';
export * as host from './host';
export * as gamepad from './gamepad';
export * as camera from './camera';
export * as process from './process';
export * as overlay from './overlay';
export * as encoder from './encoder';
export * as input from './input';
export * as hub from './hub';
export * as touch from './touch';
export * as recordControl from './recordControl';
export * as screenshotSession from './screenshotSession';
export * as macroRecorder from './macroRecorder';

export type PlaycastBodyValidator = (
  message: unknown,
) => { ok: true } | { ok: false; reason: string };

const bodyValidators = new Map<string, PlaycastBodyValidator>();

export function registerPlaycastBodyValidator(
  action: string,
  validator: PlaycastBodyValidator,
): void {
  bodyValidators.set(action, validator);
}

export const validatePlaycastMessage = (
  message: string | Record<string, unknown>,
  options?: { validateBody?: boolean },
): PlaycastMessage<PlaycastMessageTarget> | undefined => {
  let msgTarget = 'unknown';
  let msgAction = 'unknown';
  const fail = (field: string) => {
    console.error(`Failed to validate message: ${field} is required. Target: ${msgTarget}, Action: ${msgAction}`);
    return undefined;
  };

  if (typeof message === 'string') {
    try {
      message = JSON.parse(message);
    } catch (err) {
      console.error('Failed to parse message:', message);
      return undefined;
    }
  }
  const messageObj = message as PlaycastMessage<PlaycastMessageTarget>;
  try {
    const header = messageObj['header'];
    if (header === undefined) return fail('header');
    const body = messageObj['body'];
    if (body === undefined) return fail('body');

    msgTarget = header['target'] || 'unknown';
    msgAction = header['action'] || 'unknown';

    const target = header['target'];
    if (target === undefined) return fail('header.target');
    const action = header['action'];
    if (action === undefined) return fail('header.action');
    const tag = header['tag'];
    if (tag === undefined) return fail('header.tag');
    const source = header['source'];
    if (source === undefined) return fail('header.source');
    const schemaVersion = header['schemaVersion'];
    if (schemaVersion === undefined) return fail('header.schemaVersion');
    const timestamp = header['timestamp'];
    if (timestamp === undefined) return fail('header.timestamp');
    const user = header['user'];
    if (user === undefined) return fail('header.user');
    const isReply = header['isReply'];
    if (isReply === undefined) return fail('header.isReply');

    if (options?.validateBody === true) {
      const validator = bodyValidators.get(action);
      if (validator) {
        const result = validator(messageObj);
        if (result.ok === false) {
          console.error(`Failed to validate message body: ${result.reason}. Target: ${msgTarget}, Action: ${msgAction}`);
          return undefined;
        }
      }
    }
  } catch (err) {
    console.error('Failed to validate message:', err);
    return undefined;
  }
  return messageObj;
};
